module.exports = __webpack_public_path__ + "img/comp-44.3b3a1ca6.png";